const datasource = require("./datasource");
const datasearchsource = require("./datasearchsource");
const templaterenderer = require("./templaterenderer");
const view = require("./view");

const mvcobject = require("./mvcobject");
const geocoder = require("./location/geocoder");
const placessearchsource = require("./location/placessearchsource");
const directionsprovider = require("./location/directions");
const distanceprovider = require("./location/distanceprovider");

const tableview = require("./ui/tableview");
const searchview = require("./ui/searchview");
const directionsresultsdisplayer = require("./ui/directionsresultsdisplayer");
const origindestinationinput = require("./ui/origindestinationinput");
const travelmodeselector = require("./ui/travelmodeselector");

const nearbystoressource = require("./location/nearbystoressource");
const locationprovider = require("./location/locationprovider");
const delegateprotocol = require("./ui/delegate").DelegateProtocol;

exports.DataSource = datasource.DataSource;
exports.getProjectConfig = datasource.getProjectConfig;
exports.DataSearchSource = datasearchsource.DataSearchSource;
exports.TemplateRenderer = templaterenderer.TemplateRenderer;

exports.initialize = require("./initialize");

exports.utils = {
    MVCObject: mvcobject.MVCObject,
    DelegateProtocol: delegateprotocol,
};

exports.ui = {
    TableView: tableview.TableView,
    SearchView: searchview.SearchView,
    TravelModeSelector: travelmodeselector.TravelModeSelector,
    DirectionsResultsDisplayer: directionsresultsdisplayer.DirectionsResultsDisplayer,
    OriginDestinationInput: origindestinationinput.OriginDestinationInput,
};

exports.location = {
    LocationProvider: locationprovider.LocationProvider,
    NearbyStoresSource: nearbystoressource.NearbyStoresSource,
    DirectionsProvider: directionsprovider.DirectionsProvider,
    GeocoderSearchSource: geocoder.GeocoderSearchSource,
    DistanceProvider: distanceprovider.DistanceProvider,
    PlacesSearchSource: placessearchsource.PlacesSearchSource,
};

exports.template = {
    registerLambda: templaterenderer.registerLambda,
};

exports.search = {
    SearchQuery: require("./searchquery").SearchQuery,
    SearchParameters: require("./searchparameters").SearchParameters,
};
const maps = require("./maps");

exports.maps = {
    ui: maps.ui,
    utils: maps.utils,
    events: maps.events,
    geometry: maps.geometry,
    data: maps.data,
};

exports.style = require("./style");

exports.loadGoogleSubclasses = require("./initializegooglesubclasses");

exports.BaseView = require("./baseview").BaseView;
exports.View = view.View;

exports.layers = require("./layers");
exports.TiledView = require("./tiledview");

/**
 * exposed for testing purposes we need to find a solution to avoid it
 */
exports.network = require("./network");
